import { useTranslation } from "@/context/TranslationContext";

export default function LangToggle({ className = "" }: { className?: string }) {
  const { lang, translating, progress, total, toggleLang } = useTranslation();

  return (
    <button
      onClick={toggleLang}
      disabled={translating}
      title={lang === "en" ? "Translate to French" : "Switch back to English"}
      className={`relative flex items-center gap-1.5 h-9 px-2.5 rounded-lg border border-dark-border text-silver hover:text-electric-blue hover:border-electric-blue/40 transition-all cursor-pointer disabled:opacity-50 disabled:cursor-wait ${className}`}
    >
      {translating ? (
        <>
          <span className="w-3.5 h-3.5 border border-electric-blue border-t-transparent rounded-full animate-spin" />
          <span className="text-xs font-bold tracking-wider">
            {total > 0 ? `${progress}/${total}` : "..."}
          </span>
        </>
      ) : (
        <>
          <i className="ri-translate-2 text-base" />
          <span className="text-xs font-bold tracking-wider">
            {lang === "en" ? "FR" : "EN"}
          </span>
        </>
      )}
    </button>
  );
}
